import type { NodeSn } from '@ipfabric/utils';
import { type DeviceViewEntity, isNodeEntity } from '../deviceViewTypes';

export const findDeviceViewEntityByNodeSn = (
  deviceViewEntities: DeviceViewEntity[],
  nodeSn: NodeSn | null,
): DeviceViewEntity | null =>
  deviceViewEntities.find(
    (entity) => isNodeEntity(entity) && entity.sn === nodeSn,
  ) ?? null;
